import { useEffect, useRef } from 'react';
import { useAppContext } from '../../../Store/Store';

interface ProcessingScreenProps {
  onNext: () => void;
  showSkipNextScreenButton?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
}

export default function AnimationScreen({
  onNext,
  showSkipNextScreenButton = false,
  showBackButton = false,
  onBack,
}: ProcessingScreenProps) {
  const { style } = useAppContext();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleSkip = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    onNext();
  };

  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      root.style.setProperty(
        '--animation-gradient1',
        style.animation_gradient1_color
      );
      root.style.setProperty(
        '--animation-gradient2',
        style.animation_gradient2_color
      );
      root.classList.add('show-gradient');
    }
    timerRef.current = setTimeout(() => {
      onNext();
    }, 3000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (root) {
        root.classList.remove('show-gradient');
      }
    };
  }, [onNext, style]);

  return (
    <>
      <div
        style={{
          fontWeight: 'bold',
          fontSize: '140%',
          marginTop: '5%',
          textAlign: 'center',
          color: style.animation_indication_text_color || 'black',
        }}
        dangerouslySetInnerHTML={{
          __html: style.animation_indication || '',
        }}
      />
      {showBackButton && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
          }}
        >
          <button
            type="button"
            onClick={() => onBack?.()}
            style={{
              fontSize: '18px',
              textDecoration: 'underline',
              color: style?.back_button_text_color || '#07296A',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: style?.back_button_indication || 'Back',
              }}
            />
          </button>
        </div>
      )}
      {showSkipNextScreenButton && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
          }}
        >
          <button
            type="button"
            onClick={handleSkip}
            style={{
              fontSize: '18px',
              textDecoration: 'underline',
              color: style?.skip_next_screen_button_text_color || '#07296A',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: style?.skip_next_screen_button_indication || 'Skip',
              }}
            />
          </button>
        </div>
      )}
    </>
  );
}
